<template>
  <div class="overflow-x-auto scrollbar-hidden">
    <div
      id="tabulator"
      ref="tableRef"
      class="mt-5 table-report table-report--tabulator"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import langs from '@/locale.tabulator'
import serviceApi from '@/services/services/service.api'
import { statusFormatter } from '@/utils/tableFormatter'

export default defineComponent({
  data() {
    return {
      tabulator: null
    }
  },
  methods: {
    showDetail(e, cell) {
      this.$router.push({
        name: 'side-menu-services-detail',
        params: { uuid: cell.getData().uuid }
      })
    },
    showEdit(e, cell) {
      this.$router.push({
        name: 'side-menu-services-edit',
        params: { serviceId: cell.getData().uuid }
      })
    },
    detailFormatter() {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-info detail-action">' +
        this.$t('common.detail') +
        '</button></div>'
      )
    },
    editFormatter() {
      return (
        '<div class="flex lg:justify-center items-center"><button class="btn btn-primary detail-action">' +
        this.$t('common.edit') +
        '</button></div>'
      )
    },
    sortOrderFormatter(cell) {
      return `
        <div class="flex items-center justify-center space-x-2">
          <button class="btn btn-sm btn-primary-soft sort-up-action" data-uuid="${
            cell.getData().uuid
          }">
            &uarr;
          </button>
          <button class="btn btn-sm btn-primary-soft sort-down-action" data-uuid="${
            cell.getData().uuid
          }">
            &darr;
          </button>
        </div>
      `
    },
    async handleSortOrderClick(e, cell) {
      const uuid = cell.getData().uuid
      const direction = e.target.classList.contains('sort-up-action') ? 'UP' : 'DOWN'

      try {
        await serviceApi.sortOrder(uuid, { direction: direction })
        this.tabulator.replaceData()
      } catch (error) {
        console.error('Error sorting order:', error)
      }
    }
  },
  mounted() {
    const translate = this.$t
    this.tabulator = new Tabulator(this.$refs.tableRef, {
      locale: 'sk',
      langs: langs,
      ajaxURL: '#',
      ajaxConfig: 'POST',
      ajaxRequestFunc: function (url, config, params) {
        console.log(url)
        console.log(params)
        console.log(config)
        return serviceApi.getList(params.page, params.size, params.sort)
      },
      ajaxResponse: function (url, params, response) {
        const pagination = response.data.pagination
        return {
          data: response.data.data,
          last_page: Math.ceil(pagination.filtered / pagination.perPage)
        }
      },
      printAsHtml: true,
      printStyled: true,
      pagination: true,
      paginationMode: 'remote',
      paginationSize: 10,
      paginationSizeSelector: [10, 20, 30, 40],
      sortMode: 'remote',
      layout: 'fitColumns',
      responsiveLayout: 'collapse',
      placeholder: 'No matching records found',
      columns: [
        {
          formatter: 'responsiveCollapse',
          width: 40,
          minWidth: 30,
          hozAlign: 'center',
          resizable: false,
          headerSort: false
        },

        // For HTML table
        {
          title: this.$t('common.title'),
          minWidth: 200,
          responsive: 0,
          field: 'name',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${
                  cell.getData().name.sk_SK
                }</div>
              </div>`
          }
        },
        {
          title: this.$t('common.sortOrder'),
          minWidth: 50,
          responsive: 0,
          field: 'order',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${
                  cell.getData().order ?? ''
                }</div>
              </div>`
          }
        },
        {
          title: this.$t('common.duration'),
          minWidth: 50,
          headerSort: false,
          field: 'duration',
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter(cell) {
            return `<div>
                <div class="font-medium whitespace-nowrap">${
                  cell.getData().duration === null ? '&#8734;' : cell.getData().duration
                } min</div>
              </div>`
          }
        },
        {
          title: '',
          maxWidth: 150,
          field: 'status',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: (cell) => statusFormatter(cell, translate, 'She')
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionDetail',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.detailFormatter,
          cellClick: this.showDetail
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionEdit',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.editFormatter,
          cellClick: this.showEdit
        },
        {
          title: '',
          maxWidth: 150,
          field: 'actionSortOrder',
          responsive: 1,
          headerSort: false,
          hozAlign: 'center',
          vertAlign: 'middle',
          print: false,
          download: false,
          formatter: this.sortOrderFormatter,
          cellClick: this.handleSortOrderClick // Use the new handler
        }
      ]
    })
  }
})
</script>
